const Footer = () => {
  return (
    <footer className="relative bg-gradient-to-tr from-[#0f172a] to-[#1e293b] text-white">
      {/* 顶部分隔线 */}
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-indigo-500 to-transparent opacity-30"></div>

      <div className="max-w-7xl mx-auto px-6 py-10 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        {/* 左侧 LOGO + 公司名 */}
        <div className="flex flex-col items-center md:items-start text-center md:text-left space-y-2">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-indigo-500 rounded-full flex items-center justify-center text-white font-bold">
              S
            </div>
            <span className="font-semibold text-lg tracking-wide">Seton DNS</span>
          </div>
          <p className="text-sm text-slate-400 max-w-xs leading-relaxed">
            南京思顿软件科技有限公司 · 企业级 DNS 解析服务
            高可用 · 安全防护 · 全球加速
          </p>
        </div>

        {/* 右侧联系方式 + 系统状态 */}
        <div className="flex flex-col items-center md:items-end text-center md:text-right space-y-2 text-sm">
          <p className="text-slate-300">
            联系邮箱：{" "}
            <a
              href="mailto:hi@setonink.com"
              className="text-indigo-400 hover:text-indigo-300 underline transition"
            >
              hi@setonink.com
            </a>
          </p>
          <p>
            <a
              href="https://beian.miit.gov.cn"
              target="_blank"
              rel="noreferrer"
              className="text-slate-400 hover:underline"
            >
              苏ICP备2022048063号
            </a>
          </p>
          {/* 新增系统状态 */}
          <p>
            <a
              href="https://status.setondns.com"
              className="inline-flex items-center text-green-400 hover:text-green-300 transition"
            >
              <span className="relative flex h-2 w-2 mr-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
              </span>
              系统状态
            </a>
          </p>
          <p className="text-xs text-slate-500">© 2025 南京思顿软件科技有限公司</p>
        </div>
      </div>

      {/* 友情链接 */}
      <div className="max-w-7xl mx-auto px-6 pb-6">
        <div className="w-full border-t border-slate-700/50 pt-6">
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
            <span className="text-sm text-slate-400">友情链接：</span>
            <a href="https://www.1yidc.com" target="_blank" rel="noreferrer" className="text-xs text-slate-400 hover:text-indigo-400 transition">壹云数据</a>
            <a href="https://www.11dun.com" target="_blank" rel="noreferrer" className="text-xs text-slate-400 hover:text-indigo-400 transition">壹盾安全</a>
            <a href="https://openapi.setonink.com" target="_blank" rel="noreferrer" className="text-xs text-slate-400 hover:text-indigo-400 transition">思顿数据平台</a>
            <a href="https://icp-team.setonink.com" target="_blank" rel="noreferrer" className="text-xs text-slate-400 hover:text-indigo-400 transition">ICP备案查询</a>
            <a href="https://www.aiboce.com" target="_blank" rel="noreferrer" className="text-xs text-slate-400 hover:text-indigo-400 transition">爱拨测</a>
          </div>
        </div>
      </div>

      {/* 底部小字 */}
      <div className="text-center text-[11px] text-slate-500 pb-4">
        Powering business with enterprise DNS · Setonink
      </div>
    </footer>
  );
};

export default Footer;